<template>
  <v-card max-height="50vh">
    <v-card-title>{{$t('footer.dataprivacy')}}</v-card-title>
    <v-card-text>
      Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
      eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
      voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet
      clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit
      amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
      nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed
      diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.
      Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor
      sit amet.
    </v-card-text>
  </v-card>
</template>

<script>
export default {};
</script>

<style scoped>
::v-deep h1,
h2,
h3 {
  padding-bottom: 12px;
}
</style>